module.exports = __webpack_public_path__ + "media/images/application/template/spacer-d0ca72668775dc48a44a8d2bb9542760.svg";